import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import Label from '../../../../incase-domain/components/label/Label';
import {
    DEFAULT_WORD_CLOUD_PALETTE,
    WORD_CLOUD_PALETTE_IDS,
    WORD_CLOUD_PALETTES,
    WordCloudPaletteId,
} from '../../../../incase-domain/elements/question/wordCloudPalettes';

interface WordCloudPaletteSelectProps {
    value?: WordCloudPaletteId;
    onChange: (palette: WordCloudPaletteId) => void;
}

function WordCloudPaletteSelect({value, onChange}: WordCloudPaletteSelectProps): ReactElement {
    const {t} = useTranslation();
    const selected = value || DEFAULT_WORD_CLOUD_PALETTE;

    return (
        <div className="u-flex u-flex-col u-gap-2">
            <Label>{t('designSidepanel.wordCloudPalette')}</Label>
            <div className="c-sidepanel__palettes">
                {WORD_CLOUD_PALETTE_IDS.map((paletteId) => (
                    <button
                        key={paletteId}
                        type="button"
                        className={`c-sidepanel__palettes_option${selected === paletteId ? ' is-selected' : ''}`}
                        aria-pressed={selected === paletteId}
                        title={t(`designSidepanel.wordCloudPaletteOption.${paletteId}`)}
                        onClick={() => onChange(paletteId)}
                    >
                        {WORD_CLOUD_PALETTES[paletteId].map((color) => (
                            <span key={color} className="c-sidepanel__palettes_swatch" style={{backgroundColor: color}} />
                        ))}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default WordCloudPaletteSelect;
